module.exports = __webpack_public_path__ + "img/icon-warning-avalanches-red.5fa08009.svg";